






















import Vue from 'vue'
import Component from 'vue-class-component';
import { PageTitle } from '@questelservices/common-vue';
import { BatchService } from '@/service/BatchService';
import { BatchDetailsDto } from '@/models/batch/BatchDetailsDto';
import BatchDetails from '@/components/batch/batch-details.vue';
import { BatchTypes } from '../../models/batch/BatchTypeEnum';
import { DxSelectBox } from 'devextreme-vue';
import { SelectOption } from '@/models/SelectOption';
import { BatchDto } from '@/models/batch/BatchDto';
import { alert } from 'devextreme/ui/dialog';    

@Component({
  components: {
    PageTitle,
    BatchDetails,
    DxSelectBox
  }
})
export default class Batch extends Vue {
  batch: BatchDetailsDto | null = null
  batchTypes: SelectOption[] = BatchTypes;

  private get batchId(): Guid | undefined {
    return this.$route.params.id;
  }

  private get batchTypeId(): any {
    return this.batch != null ? this.batch.BatchTypeId : undefined;
  }

  private set batchTypeId(batchTypeId: any) {
    if (this.batch !== null ) {
      this.batch.BatchTypeId = batchTypeId;
    }
  }

  private get batchName(): string | undefined {
    return this.batch != null ? this.batch.BatchName : undefined;
  }


  private batchService: BatchService = new BatchService();

  async mounted() {
    if(this.batchId) {
      this.batch = await this.batchService.getBatchDetails(this.batchId);      
      // Set a client id as a route parameter so the breadcrumb will load the selected client
      this.$route.params['clientId'] = this.batch.ClientId;
    }
  }

  async hidingDeleteBatchData() {
    if(this.batchId) {
      this.batch = await this.batchService.getBatchDetails(this.batchId);        
    }    
  }

  private onBatchTypeChanged(event: any) {
    if (event.previousValue === undefined) {
      return;
    }    

    if (this.batch != undefined) {
      let batchDto: BatchDto = {
        BatchId: this.batch.BatchId,
        BatchName: this.batch.BatchName,
        BatchTypeId: this.batch.BatchTypeId
      };

      this.batchService.updateBatch(this.batch.BatchId, batchDto)
        .then(result => {
          let batchTypeName = this.batchTypes.filter(bt => bt.value == result.BatchTypeId)[0].text;
          let message = `Batch Type set to ${batchTypeName} for Batch ${result.BatchName}.`;
          alert(message, 'Batch Type Updated');
        })
        .catch(error => {
          let message = `There was an error setting the Batch Type for Batch ${this.batchName}.`;
          alert(message, 'Error');
        });
      } 
  }    
}
